module.exports = __webpack_public_path__ + "img/ic_coins.818153fe.png";